import * as actions from "../actions/alerting";

const alertsInitialState = {
  alerts: [],
  loading: true,
};

const alertsReducer = (state = alertsInitialState, action) => {
  switch (action.type) {
    case "RESET_STORE":
      return {
        ...alertsInitialState,
      };
    case actions.FETCH_ALERTS:
      return {
        ...state,
        loading: true,
      };
    case actions.UPDATE_FETCH_ALERTS:
      return {
        ...state,
        alerts: action.payload.alerts,
        alertsPageMeta: action.payload.alertsPageMeta,
        loading: false,
      };
    case actions.CLEAR_ALERT_LIST:
      return {
        ...state,
        alerts: [],
        loading: false,
      };
    case actions.SILENCE_ALERT:
      return { ...state, ...action.payload.nextState };
    case actions.UNSILENCE_ALERT:
      return { ...state, ...action.payload.nextState };
    case actions.UPDATE_SILENCE_ALERT:
    case actions.UPDATE_UNSILENCE_ALERT:
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default alertsReducer;
